import { Id, Row } from "@dgs/core";
import { useField } from "formik";
import { TFunction } from "i18next";
import styled from "styled-components";
import { PaymentProviderOptionResource, RegistrationShopSummaryResource } from "../../../shared/types";

const Error = styled.div`
	${({ theme }) => theme.forms.error};
`;

const PaymentProviderButton = styled.button<{ $active: boolean }>`
	font: inherit;
	padding: ${({ theme }) => theme.spacing(8)};
	background: ${({ theme, $active }) =>
			$active ? theme.colors.palette.primary.main.base : theme.colors.palette.grey[10]}
		none;
	color: ${({ theme, $active }) => ($active ? theme.colors.palette.primary.main.contrast : "inherit")};
	border: 1px solid ${({ theme, $active }) => ($active ? "transparent" : theme.colors.card.background.outline)};
	border-radius: 8px;
	cursor: pointer;
`;

interface Props {
	paymentProviders: PaymentProviderOptionResource[];
}

export function toPaymentProviderErrors(
	shopSummaryResource: RegistrationShopSummaryResource,
	paymentProviderId: Id | null,
	t: TFunction,
) {
	const errors: { paymentProviderId?: Id | null } = {};

	if (shopSummaryResource.transactionItemsToBePaidNow.length > 0 && paymentProviderId === null) {
		errors.paymentProviderId = t("Field is required");
	}

	return errors;
}

export function PaymentProviderSelect({ paymentProviders }: Props) {
	const name = "paymentProviderId";
	const [field, meta] = useField(name);

	return (
		<>
			<Row>
				{paymentProviders.map((p) => (
					<PaymentProviderButton
						type="button"
						key={p.id}
						$active={field.value === p.id}
						onClick={() => field.onChange({ target: { name, value: p.id } })}
					>
						{p.label}
					</PaymentProviderButton>
				))}
			</Row>
			{meta.touched && meta.error && <Error>{meta.error}</Error>}
		</>
	);
}
